/** How long an offline check-in may wait to be replayed and keep its own time. */
export const CHECK_IN_REPLAY_WINDOW_MS = 24 * 60 * 60 * 1000;
/**
 * How many people the door should expect from a guest: the party coming when
 * they said yes, nobody when they said no, and the party invited while they
 * have not answered (or said maybe) — never fewer than one, since a guest on
 * the list who has not declined is at least themselves.
 */
export function expectedArrivals(attendance) {
    if (attendance.response === 'NO')
        return 0;
    if (attendance.response === 'YES')
        return Math.max(attendance.total, 1);
    return Math.max(attendance.invitedTotal, 1);
}
/** Nobody yet, some of the party, or all of it (or more than expected). */
export function arrivalState(arrived, expected) {
    if (arrived <= 0)
        return 'NOT_ARRIVED';
    return arrived >= Math.max(expected, 1) ? 'ARRIVED' : 'PARTIAL';
}
/**
 * When a check-in happened. A check-in queued offline carries the moment it
 * was scanned; one claiming to be in the future, unreadable, or older than
 * the replay window is recorded as now.
 */
export function checkInTime(at, now = new Date()) {
    if (!at)
        return now;
    const when = at instanceof Date ? at : new Date(at);
    const t = when.getTime();
    if (!Number.isFinite(t) || t > now.getTime() || now.getTime() - t > CHECK_IN_REPLAY_WINDOW_MS) {
        return now;
    }
    return when;
}
//# sourceMappingURL=checkIn.js.map